import Clarity from '@microsoft/clarity'
import * as Sentry from '@sentry/vue'
import posthog from 'posthog-js'
import { createApp } from 'vue'

import App from '@/App.vue'
import { router } from '@/plugins/1.router'
import { registerPlugins } from '@core/utils/plugins'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Create vue app
const app = createApp(App)

// Sentry error monitoring
Sentry.init({
  app,
  dsn: 'https://a7aeb3d3f8755e32d3c5eb3a90c5ccb1@sentry.senai.br/74',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

// Suppress known harmless warning from defineAsyncComponent + VueUse lifecycle hooks
if (import.meta.env.DEV) {
  app.config.warnHandler = (msg, _instance, trace) => {
    if (msg.includes('onMounted is called when there is no active component instance'))
      return

    console.warn(`[Vue warn]: ${msg}${trace}`)
  }
}

// Register plugins
registerPlugins(app)

// Clarity analytics
Clarity.init('rb7bdhbr3y')

posthog.init(import.meta.env.VITE_POSTHOG_TOKEN, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  capture_pageview: false,
})

router.afterEach(() => {
  posthog.capture('$pageview')
})

// Mount vue app
app.mount('#app')
